angular.module('trainerWebApp.resources').factory('CourseCtrlResolver',
  ['$q', '$route', 'Auth', 'courseTraineesResource', 'Validation', '$location', 'usersResource', 'mtypes', 'CustomEmailResource', function ($q, $route, Auth, courseTraineesResource, Validation, $location, usersResource, mtypes, CustomEmailResource) {

    return function () {
      var deferred = $q.defer();
      var pageName = $route.current.params.pageName || $route.current.pageName;
      var courseId = $route.current.params.courseId;

      var authorize = function () {
          return Auth.getRolePromise().then(function () {
            return;
          });
        },

        traineesSetup = function () {
          return courseTraineesResource.traineesSetup(courseId).$promise.then(function (result) {
            checkCourseStatus(result);
          });
        },

        getAddUserSetupForCourse = function () {
          return usersResource.getAddUserSetupForCourse(courseId).$promise.then(function (result) {
            checkCourseStatus(result);
          });
        },

        inviteSetup = function () {
          return courseTraineesResource.inviteSetup(courseId).$promise.then(function (result) {
            checkCourseStatus(result);
          });
        },

        getCourseStatus = function () {
          return courseTraineesResource.getCourseStatus(courseId).$promise.then(function (result) {
            checkCourseStatus(result);
          });
        },

        getCourseEmails = function () {
          return CustomEmailResource.getCourseEmails(courseId).$promise.then(function (result) {
            checkCourseStatus(result);
          });

        };

      function checkCourseStatus(result) {
        var status = '';
        var retVal = result;

        if ('status' in result) {
          status = result.status;
        }

        if ('courseStatus' in result) {
          status = result.courseStatus ? result.courseStatus.status : '';
        }

        sendResult(status, retVal);
      }

      function sendResult(status, result) {
        if([mtypes.courseStatus.archive, mtypes.courseStatus.active, mtypes.courseStatus.draft].indexOf(status) < 0) {
          // we want a 500 page since the course id doesn't exist ie someone changed it in the url
          deferred.reject({courseId: courseId});
          return;
        }

        if (!isDefaultPageName() && status == mtypes.courseStatus.archive) {
          deferred.reject(rejectReasonWithRedirect());
        } else {
          deferred.resolve(result);
        }
      }

      function rejectReasonWithRedirect() {
        var path = $location.path();
        return { redirectUrl: path.substr(0, path.lastIndexOf('/')) + '/trainees'};
      }

      function isDefaultPageName() {
        return !pageName || pageName == 'trainees';
      }

      // let the controller handle the validate first
      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      // If redirecting to Flex then quit out before trying to hit gaviota-api for data.
      if (!courseId && !pageName)
        return;

      if (!courseId) {
        authorize().then(function () {
          deferred.reject({courseId: 'invalid'});
        });
        return deferred.promise;
      }


      if (isDefaultPageName()) {
        authorize().then(traineesSetup);
      }
      else if (pageName == 'addNewUser') {
        authorize().then(getAddUserSetupForCourse);
      }
      else if (pageName == 'addExistingTrainees') {
        authorize().then(inviteSetup);
      }
      else if (pageName == 'addYammerUsers') {
        authorize().then(getCourseStatus);
      }
      else if (pageName == 'importXls') {
        authorize().then(getCourseStatus);
      }
      else if (pageName == 'courseEmails') {
        authorize().then(getCourseEmails);
      }

      return deferred.promise;
    };
  }]
);
